module.exports = __webpack_public_path__ + "static/img/encyclopediaIndexLogo.be9fcb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/testTubeEncyclopedia/images/encyclopediaIndexLogo.jpg
// module id = nS2G
// module chunks = 5